import { CheckIcon, CopyIcon } from '@phosphor-icons/react';
import { useEffect, useRef, useState } from 'react';

import styles from './copy-to-clipboard.module.scss';

export type CopyToClipboardProps = {
  value: string;
  className?: string;
};

const CONFIRM_MS = 1500;

export function CopyToClipboard({ value, className }: CopyToClipboardProps) {
  const [copied, setCopied] = useState(false);
  const timer = useRef<number>(undefined);

  useEffect(() => () => window.clearTimeout(timer.current), []);

  const onCopy = async () => {
    await navigator.clipboard.writeText(value);
    setCopied(true);
    window.clearTimeout(timer.current);
    timer.current = window.setTimeout(() => setCopied(false), CONFIRM_MS);
  };

  return (
    <button
      type="button"
      aria-label={copied ? 'Copied' : 'Copy'}
      className={[styles.button, className].filter(Boolean).join(' ')}
      onClick={onCopy}
    >
      {copied ? <CheckIcon size={14} aria-hidden /> : <CopyIcon size={14} aria-hidden />}
    </button>
  );
}
